import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';

import { getToast } from '../utils/toastConfig';
import { GlobalVariables } from '../globalVar';
import customAxios from '../utils/customAxios';
import { LocationTable } from '../components/Tables/LocationTable';

const HEADERS = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token'),
  },
};

const LocationPage = () => {
  const [isFetching, setIsFetching] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsFetching(true);
    try {
      const endpoint = `${GlobalVariables.getURL()}locations-assets/?includeInactive=true`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 204) {
        setData([]);
        return;
      }

      console.log('Fetched locations response:', response);

      setData(response.data.data || response.data || []);
    } catch (error) {
      console.log('Error fetching locations:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <div className='table-module-container'>
      <Helmet>
        <title>DABI | Ubicaciones</title>
      </Helmet>
      <div className='datatable'>
        <LocationTable
          data={data}
          isFetching={isFetching}
          fetchData={fetchData}
        />
      </div>
    </div>
  );
};

export default LocationPage;
